import type { ReactNode } from 'react';

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return (
    <section className="empty-state">
      <img src="/brand/pipi-karaoke-mascot.png" alt="" />
      <div>
        <span className="eyebrow">皮皮在这里</span>
        <h2>{title}</h2>
        <p>{description}</p>
        {action}
      </div>
    </section>
  );
}
